import React, { useEffect } from "react"
import { Trans } from "@lingui/macro"
import { useLingui } from "@lingui/react"
import ErrorBox from "../components/ErrorBox/ErrorBox"
import { useGeolocation } from "../app-core/_common/providers/geolocation-provider"
import { build404DataLayer } from "../app-core/features/_common/tracking/page-data-layer"
import { PageViewAnalytics } from "../app-core/features/_common/hooks/use-page-view-analytics"

const useBuild404DataLayer = () => {
    const { i18n } = useLingui()
    const geolocation = useGeolocation()

    return build404DataLayer(i18n.locale, geolocation)
}

const Page404: React.FC<React.PropsWithChildren<unknown>> = () => {
    const pageDataLayer = useBuild404DataLayer()
    useEffect(() => {
        if (window.rollbar) window.rollbar.warning("404 Error", { referrerUrl: document.referrer })
    })

    return (
        <>
            <PageViewAnalytics data={pageDataLayer} />
            <ErrorBox
                title={<Trans>Page not found</Trans>}
                button={{
                    label: <Trans>Find a Cruise</Trans>,
                    onClick: () => (window.location.href = "https://www.silversea.com"),
                }}
                // message={<Trans>Cruise not found.</Trans>}
            />
        </>
    )
}

export default Page404
